module.exports = __webpack_public_path__ + "img/MEDIA025.7d1c5618.jpg";